import { render, staticRenderFns } from "./TravelNoteDetailSlideTop.vue?vue&type=template&id=56f4c4d6&scoped=true"
import script from "./TravelNoteDetailSlideTop.vue?vue&type=script&lang=js"
export * from "./TravelNoteDetailSlideTop.vue?vue&type=script&lang=js"
import style0 from "./TravelNoteDetailSlideTop.vue?vue&type=style&index=0&id=56f4c4d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f4c4d6",
  null
  
)

export default component.exports